module.exports = __webpack_public_path__ + "static/media/00.97f9fed9.jpg";